/**
 * 企业相关接口
 */
import request from './request'

/**
 * 获取企业信息
 */
export function getCompanyInfo() {
  return request.post('/api/company/home/getCompanyInfo')
}

/**
 * 更新企业头像
 * @param {string} avatar - 头像图片地址
 */
export function updateAvatar(avatar) {
  return request.post('/api/company/home/updateAvatar', { avatar })
}

/**
 * 更新企业简称
 * @param {string} companyShortName - 企业简称
 */
export function updateShortName(companyShortName) {
  return request.post('/api/company/home/updateShortName', { companyShortName })
}

/**
 * 修改绑定手机
 * @param {object} params - { code, newMobile, password }
 */
export function changePhone(params) {
  return request.post('/api/company/home/changePhone', params)
}

/**
 * 修改登录密码
 * @param {object} params - { mobile, code, password }
 */
export function changePassword(params) {
  return request.post('/api/company/home/changePassword', params)
}

/**
 * 提交/更新企业认证信息
 * @param {object} params - 企业认证完整参数
 */
export function completeCompany(params) {
  return request.post('/api/company/home/completeCompany', params)
}

/**
 * 获取企业首页数据
 */
export function getCompanyIndexInfo() {
  return request.post('/api/company/home/getIndexInfo')
}
